import React from 'react'
import { TiTick } from "react-icons/ti";
import { Link } from 'react-router-dom';
import { TbUsers } from "react-icons/tb";
import { MdAccessTime } from "react-icons/md";
import { useTranslation } from 'react-i18next';
import CryoFacial from "../assets/cryoFacial.png"
import LocalizedCryo from "../assets/localizeCryo.png"
// import Image3 from "../assets/Gallery-Photos/cryotherapy-facial.jpg";
import EyeExtenstion from "../assets/eyeExtension.png"
import Massage from "../assets/Gallery-Photos/couple-maassage.png"
import CryoSlimming from "../assets/Gallery-Photos/cryo-slimming.webp";


const ServiceHighlights = () => {
  const { t } = useTranslation();

    const services = [
            {
              key: 'ServiceHighlightCryoSlimming',
              image: CryoSlimming,
              heading: t('ServiceHighlightCryoSlimming.heading'),
              para: t('ServiceHighlightCryoSlimming.para'),
              benefits: t('ServiceHighlightCryoSlimming.benefits'),
              benefitsLi1: t('ServiceHighlightCryoSlimming.benefitsLi1'),
              benefitsLi2: t('ServiceHighlightCryoSlimming.benefitsLi2'),
              benefitsLi3: t('ServiceHighlightCryoSlimming.benefitsLi3'),
              idealFor: t('ServiceHighlightCryoSlimming.idealFor'),
              idealForText: t('ServiceHighlightCryoSlimming.idealForText'),
              duration: t('ServiceHighlightCryoSlimming.duration'),
            },
            {
                key: 'ServiceHighlightLocalizedCryo',
                image: LocalizedCryo,
                heading: t('ServiceHighlightLocalizedCryo.heading'),
                para: t('ServiceHighlightLocalizedCryo.para'),
                benefits: t('ServiceHighlightLocalizedCryo.benefits'),
                benefitsLi1: t('ServiceHighlightLocalizedCryo.benefitsLi1'),
                benefitsLi2: t('ServiceHighlightLocalizedCryo.benefitsLi2'),
                benefitsLi3: t('ServiceHighlightLocalizedCryo.benefitsLi3'),
                idealFor: t('ServiceHighlightLocalizedCryo.idealFor'),
                idealForText: t('ServiceHighlightLocalizedCryo.idealForText'),
                duration: t('ServiceHighlightLocalizedCryo.duration'),
              },
              {
                key: 'CryoFacial',
                image: CryoFacial,
                heading: t('CryoFacial.heading'),
                para: t('CryoFacial.para'),
                benefits: t('CryoFacial.benefits'),
                benefitsLi1: t('CryoFacial.benefitsLi1'),
                benefitsLi2: t('CryoFacial.benefitsLi2'),
                benefitsLi3: t('CryoFacial.benefitsLi3'),
                idealFor: t('CryoFacial.idealFor'),
                idealForText: t('CryoFacial.idealForText'),
                duration: t('CryoFacial.duration'),
              },
              // {
              //   key: 'Cryotherapy',
              //   image: Image3,
              //   heading: t('Cryotherapy.heading'),
              //   para: t('Cryotherapy.para'),
              //   benefits: t('Cryotherapy.benefits'),
              //   benefitsLi1: t('Cryotherapy.benefitsLi1'),
              //   benefitsLi2: t('Cryotherapy.benefitsLi2'),
              //   benefitsLi3: t('Cryotherapy.benefitsLi3'),
              //   idealFor: t('Cryotherapy.idealFor'),
              //   idealForText: t('Cryotherapy.idealForText'),
              //   duration: t('Cryotherapy.duration'),
              // },
              {
                key: 'TherapeuticMassage',
                image: Massage,
                heading: t('TherapeuticMassage.heading'),
                para: t('TherapeuticMassage.para'),
                benefits: t('TherapeuticMassage.benefits'),
                benefitsLi1: t('TherapeuticMassage.benefitsLi1'),
                benefitsLi2: t('TherapeuticMassage.benefitsLi2'),
                benefitsLi3: t('TherapeuticMassage.benefitsLi3'),
                idealFor: t('TherapeuticMassage.idealFor'),
                idealForText: t('TherapeuticMassage.idealForText'),
                duration: t('TherapeuticMassage.duration'),
              },
              {
                key: 'eyeleshExtension',
                image: EyeExtenstion,
                heading: t('eyeleshExtension.heading'),
                para: t('eyeleshExtension.para'),
                benefits: t('eyeleshExtension.benefits'),
                benefitsLi1: t('eyeleshExtension.benefitsLi1'),
                benefitsLi2: t('eyeleshExtension.benefitsLi2'),
                benefitsLi3: t('eyeleshExtension.benefitsLi3'),
                idealFor: t('eyeleshExtension.idealFor'),
                idealForText: t('eyeleshExtension.idealForText'),
                duration: t('eyeleshExtension.duration'),
              },
          ];
    
  return (
    <div className='container mx-auto mb-24'>
        {services.map((service, key)=> (
            <div key={key} className='flex md:flex-row flex-col p-6 justify-center gap-5 mt-16'>
                <div>
                    <img src={service.image} className='md:w-80 w-full h-96 object-cover rounded-lg' alt="" />
                </div>
                <div className='md:w-2/4'>
                    <h1 className='text-2xl font-Merriweather font-semibold'>{service.heading}</h1>
                    <p className='text-gray-600 my-3 text-xs md:text-sm font-medium'>{service.para}</p>
                    <h3 className='text-xl font-medium mb-2 font-Merriweather'>{service.benefits}</h3>
                    <ul className='flex flex-wrap gap-3'>
                        <li className='px-3 py-2 text-xs md:text-sm font-semibold bg-gray-100 rounded-xl flex items-center'><TiTick className='text-2xl text-green-600' /> {service.benefitsLi1}</li>
                        <li className='px-3 py-2 text-xs md:text-sm font-semibold bg-gray-100 rounded-xl flex items-center'><TiTick className='text-2xl text-green-600' /> {service.benefitsLi2}</li>
                        <li className='px-3 py-2 text-xs md:text-sm font-semibold bg-gray-100 rounded-xl flex items-center'><TiTick className='text-2xl text-green-600' /> {service.benefitsLi3}</li>
                    </ul>
                    <h3 className='text-xl mt-4 font-Merriweather font-medium'>{service.idealFor}</h3>
                    <p className='text-gray-600 font-semibold text-xs md:text-sm mt-2 flex gap-1'><TbUsers className='text-xl' /> {service.idealForText}</p>
                    <div className='flex justify-between items-center'>
                        <p className='flex gap-1 text-gray-600 font-semibold text-xs md:text-sm items-center'><MdAccessTime className='text-xl'/> {service.duration}</p>
                        <Link to="https://www.vagaro.com/artistryspanwellness" target="_blank">
                        <button className='p-2.5 bg-gray-900 text-white rounded-md'>{t('bookNow')}</button>
                        </Link>
                    </div>
                </div>
            </div>
        ))}
    </div>
  )
}

export default ServiceHighlights